<template>
  <div id='oa' v-loading=loading>
    <div id=''>
      <el-table
      @row-click='cellClick'
	    :data="tableData"
	    border
	    tooltip-effect="dark"
	    style="width: 100%">
  	    <el-table-column
          align=center
  	      prop='mechanismName'
  	      :label="$t('app_distributor')"
  	      width="">
  	    </el-table-column>
  	    <el-table-column
          align=center
  	      prop="nums"
  	      :label="$t('app_deviceNum')"
  	      width="">
  	    </el-table-column>
  	    <el-table-column
          align=center
  	      prop="pushTime"
  	      :label="$t('app_pushTime')"
  	      width=''>
  	    </el-table-column>
  	    <el-table-column
  	      prop="operate"
          align=center
  	      :label="$t('app_operate')"
  	      width='80'>
  	      <template slot-scope='scope'>
  	        <!-- <el-button type='text' @click='deleteRow(scope.row)'>{{$t('app_clear')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_clear')" placement="top">
              <el-button type='text' @click='deleteRow(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
  	      </template>
  	    </el-table-column>
  	  </el-table>
    </div>

    <!-- <div class="block" style='float:right;margin-top:20px;'>

      <el-pagination
        @current-change="pageSelect"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div> -->

  </div>
</template>

<style>
  #oa{}
</style>

<script>
  export default{
    data () {
      return {
        row: this.$gRow,
        total: 0,
        page: 1,
        tableData: [],
        info: '',
        loading: 0
      }
    },
    components: {},
    computed: {
    },
    methods: {
      deleteRow (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_sureDelTip'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$delAnimatePushHis(row.mechanismId, this.info.animatId, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          }) 
        }, '')
      },
      getList () {
        var aId = this.info.animatId
        console.log('aid', aId)
        this.loading = 1
        this.$pushAnimateHistory(aId, (res) => {
          console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.tableData = res.data
          }
        }, () => {
          this.loading = 0
          // error
        })
      }
    },
    mounted () {
      this.info = this.$getWObj().animatePushInfo
      this.getList()
    }
  }
</script>



// WEBPACK FOOTER //
// pushHistory.vue?0bf0804a